import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AllProvider } from './context/ContextAll';
import { BrowserRouter } from 'react-router-dom'; // ✅ Importa BrowserRouter

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> 
      <AllProvider>
        <App />
      </AllProvider>
    </BrowserRouter>
  </React.StrictMode>
);
